// 1. All imports MUST be at the very top
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope, FaChevronDown, FaChevronRight } from "react-icons/fa";
// Ensure this path is correct for your project structure
import "../styles/Navbar.css";

// 2. Data constants
const knowledgeMenu = [
  "Calculators", "Bulletins", "Utilities", "Links", "Acts", "Rules", "Forms"
];

// ✅ UPDATED: Added Important Links
const knowledgeLinksSubmenu = [
  "GST/VAT Links",
  "Important Links"
];

// 3. Component definition
export default function Navbar() {
  const [showKnowledgeDropdown, setShowKnowledgeDropdown] = useState(false);

  const [showLinksSubMenu, setShowLinksSubMenu] = useState(false);

  const [scrolled, setScrolled] = useState(false);
  const [isPhoneHovered, setIsPhoneHovered] = useState(false);
  const [isEmailHovered, setIsEmailHovered] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleKnowledgeDropdown = (e) => {
    if (sidebarOpen) {
      e.stopPropagation();
      setShowKnowledgeDropdown(!showKnowledgeDropdown);
      setShowLinksSubMenu(false);
    }
  };

  const closeAllMenus = () => {
    setSidebarOpen(false);
    setShowKnowledgeDropdown(false);
    setShowLinksSubMenu(false);
  };

  const topNavLinkStyle = {
    color: "rgba(255, 255, 255, 0.9)",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    transition: "0.3s",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer"
  };

  const getRevealTextStyle = (isHovered) => ({
    maxWidth: (!scrolled || isHovered) ? "300px" : "0px",
    opacity: (!scrolled || isHovered) ? 1 : 0,
    overflow: "hidden",
    transition: "all 0.5s ease-in-out",
    whiteSpace: "nowrap",
    display: "block"
  });

  return (
    <nav style={{
      width: "100%",
      position: "fixed",
      top: 0,
      zIndex: 2000,
      boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.15)" : "0 4px 15px rgba(0,0,0,0.1)",
      transition: "0.4s ease-in-out"
    }} className="main-nav-bar">

      {/* --- 1. TOP BAR (Desktop Links) --- */}
      <div className="nav-links-container" style={{
        backgroundColor: scrolled ? "#071a2b" : "#0f2b46",
        padding: "10px 60px",
        display: "flex",
        justifyContent: "center",
        gap: "35px",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        transition: "0.4s"
      }}>
        <Link to="/" style={topNavLinkStyle} className="nav-link">HOME</Link>
        <Link to="/about" style={topNavLinkStyle} className="nav-link">ABOUT US</Link>
        <Link to="/services" style={topNavLinkStyle} className="nav-link">SERVICES</Link>

        {/* KNOWLEDGE BANK Dropdown (Desktop) */}
        <div
          onMouseEnter={() => setShowKnowledgeDropdown(true)}
          onMouseLeave={() => { setShowKnowledgeDropdown(false); setShowLinksSubMenu(false); }}
          onClick={window.innerWidth <= 768 ? toggleKnowledgeDropdown : undefined}
          style={{ ...topNavLinkStyle, position: "relative" }}
          className={`nav-link dropdown-wrapper ${showKnowledgeDropdown ? "active" : ""}`}
        >
          KNOWLEDGE BANK <FaChevronDown className="dropdown-chevron" style={{ fontSize: "10px" }} />
          {showKnowledgeDropdown && (
            <div style={{
              position: "absolute",
              top: "28px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#ffffff",
              width: "200px",
              borderRadius: "4px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              overflow: "visible",
              borderTop: "3px solid #22c55e",
              zIndex: 3000
            }}>
              {knowledgeMenu.map((item, i) => (
                <div key={i} className={`dropdown-item ${item === "Links" ? "has-nested-submenu" : ""}`} style={{ padding: "12px 20px", cursor: "pointer", color: "#0f2b46", position: 'relative' }}>
                  {item}
                  {item === "Links" && <FaChevronRight className="nested-chevron" style={{ fontSize: "10px", marginLeft: "auto" }} onClick={(e) => { e.stopPropagation(); setShowLinksSubMenu(!showLinksSubMenu); }} />}

                  {/* Nested Submenu (Links) for Desktop */}
                  {item === "Links" && showLinksSubMenu && (
                    <div className="desktop-nested-submenu" style={{ position: 'absolute', left: '100%', top: 0, background: '#fff', width: '180px', borderRadius: '4px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', borderTop: '2px solid #22c55e' }}>
                      {knowledgeLinksSubmenu.map((subItem, j) => (
                        <div
                          key={j}
                          style={{ padding: '10px 15px', color: '#0f2b46', fontSize: '13px' }}
                          onClick={() => {
                            if (subItem === "GST/VAT Links") {
                              navigate("/gst-vat-links");
                            } else if (subItem === "Important Links") {
                              navigate("/important-links");
                            }
                            closeAllMenus();
                          }}
                        >
                          {subItem}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <Link to="/contact" style={topNavLinkStyle} className="nav-link">CONTACT</Link>
      </div>

      {/* --- 2. MAIN BAR (Logo and Contact Info) --- */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: scrolled ? "8px 60px" : "15px 60px",
        background: scrolled ? "rgba(255, 255, 255, 0.95)" : "#ffffff",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "0.4s"
      }}>

        <div onClick={() => { navigate("/"); closeAllMenus(); }} style={{ cursor: "pointer" }}>
          <h2 style={{
            margin: 0,
            color: "#0f2b46",
            letterSpacing: "1px",
            fontWeight: "900",
            fontSize: scrolled ? "20px" : "24px",
            transition: "0.3s"
          }}>
            CS MANOJ <span style={{ color: "#22c55e" }}>&</span> ASSOCIATES
          </h2>
          <div style={{
            fontSize: "11px",
            color: "#64748b",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "2px",
            display: scrolled ? "none" : "block"
          }} className="sub-logo-text">
            Company Secretaries & Legal Advisors
          </div>
        </div>

        <div className="contact-info-section" style={{ display: "flex", gap: "25px" }}>

          <div
            onMouseEnter={() => setIsPhoneHovered(true)}
            onMouseLeave={() => setIsPhoneHovered(false)}
            style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
          >
            <div style={{ backgroundColor: "#f0fdf4", padding: scrolled ? "8px" : "12px", borderRadius: "10px", transition: "0.3s" }}>
              <FaPhoneAlt style={{ color: "#22c55e", fontSize: scrolled ? "14px" : "16px" }} />
            </div>
            <div style={getRevealTextStyle(isPhoneHovered)}>
              <div style={{ fontWeight: "700", fontSize: "10px", color: "#64748b", textTransform: "uppercase" }}>Call Us</div>
              <div style={{ fontSize: "14px", color: "#0f2b46", fontWeight: "700" }}>+91 97731 12128</div>
            </div>
          </div>

          <div
            onMouseEnter={() => setIsEmailHovered(true)}
            onMouseLeave={() => setIsEmailHovered(false)}
            style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
          >
            <div style={{ backgroundColor: "#eff6ff", padding: scrolled ? "8px" : "12px", borderRadius: "10px", transition: "0.3s" }}>
              <FaEnvelope style={{ color: "#2563eb", fontSize: scrolled ? "14px" : "16px" }} />
            </div>
            <div style={getRevealTextStyle(isEmailHovered)}>
              <div style={{ fontWeight: "700", fontSize: "10px", color: "#64748b", textTransform: "uppercase" }}>Mail Us</div>
              <div style={{ fontSize: "14px", color: "#0f2b46", fontWeight: "700" }}>office@csmanojayadi.com</div>
            </div>
          </div>
        </div>

        <div
          className="hamburger"
          onClick={() => setSidebarOpen(true)}
          style={{ fontSize: "24px", cursor: "pointer", color: "#0f2b46" }}
        >
          ☰
        </div>
      </div>

      {/* --- 3. MOBILE SIDEBAR --- */}
      <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header" style={{ textAlign: "right", padding: "20px", cursor: "pointer" }}>
          <span onClick={() => { closeAllMenus(); }} style={{ fontSize: "24px" }}>✕</span>
        </div>

        <div className="sidebar-links" style={{ padding: "0 20px" }}>
          <Link to="/" className="sidebar-link" onClick={() => { navigate("/"); closeAllMenus(); }}>HOME</Link>
          <Link to="/about" className="sidebar-link" onClick={() => { navigate("/about"); closeAllMenus(); }}>ABOUT US</Link>
          <Link to="/services" className="sidebar-link" onClick={() => { navigate("/services"); closeAllMenus(); }}>SERVICES</Link>

          <div className="sidebar-link sidebar-dropdown" onClick={toggleKnowledgeDropdown}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              KNOWLEDGE BANK
              <FaChevronDown style={{ fontSize: "10px", marginLeft: "5px" }} />
            </span>
            {showKnowledgeDropdown && (
              <div className="sidebar-submenu">
                {knowledgeMenu.map((item, i) => (
                  <div
                    key={i}
                    className={`sidebar-submenu-item ${item === "Links" ? "has-nested-submenu" : ""}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%"
                    }}
                  >
                    {/* TEXT */}
                    <span>{item}</span>

                    {/* ✅ NEW ARROW */}
                    {item === "Links" && (
                      <FaChevronRight
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          transition: "0.3s",
                          transform: showLinksSubMenu ? "rotate(90deg)" : "rotate(0deg)",
                          color: "#fff",
                          marginLeft: "10px"
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowLinksSubMenu(!showLinksSubMenu);
                        }}
                      />
                    )}

                    {item === "Links" && showLinksSubMenu && (
                      <div className="sidebar-nested-submenu" style={{ paddingLeft: '15px', marginTop: '5px', borderLeft: '1px solid rgba(255,255,255,0.1)' }}>
                        {knowledgeLinksSubmenu.map((subItem, j) => (
                          <div
                            key={j}
                            style={{ padding: '5px 0', color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}
                            onClick={() => {
                              if (subItem === "GST/VAT Links") {
                                navigate("/gst-vat-links");
                              } else if (subItem === "Important Links") {
                                navigate("/important-links");
                              }
                              closeAllMenus();
                            }}
                          >
                            {subItem}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <Link to="/contact" className="sidebar-link" onClick={() => { navigate("/contact"); closeAllMenus(); }}>CONTACT</Link>
        </div>
      </div>

    </nav>
  );
}